import { useSelector } from 'react-redux'
import { connectorActionModuleSelector } from '@redux/slices/connectorSlice'

interface UseWebchatResult {
  openWebchat: () => void
  hideWebchat: () => void
  toggleWebchat: () => void
  resetWebchat: () => void
}

export const useWebchat = (): UseWebchatResult => {
  const actionModule = useSelector(connectorActionModuleSelector)

  const openWebchat = () => actionModule?.onChatWidgetAction('open')

  const hideWebchat = () => actionModule?.onChatWidgetAction('hide')

  const toggleWebchat = () => actionModule?.onChatWidgetAction('toggle')

  const resetWebchat = () => actionModule?.onChatWidgetAction('reset')

  return {
    openWebchat,
    hideWebchat,
    toggleWebchat,
    resetWebchat,
  }
}